import { css, styled } from 'styled-components';

type StyledFormFieldHelpProps = {
  hasError: boolean;
  isDisabled?: boolean;
};

export const StyledFormFieldHelp = styled.div<StyledFormFieldHelpProps>`
  ${({ hasError, isDisabled = false, theme }) => css`
    margin-top: 4px;

    color: ${isDisabled ? theme.colorsV2.gray40 : theme.colorsV2.gray60};
    font-size: 12px;

    ${hasError &&
    css`
      display: none;
    `}
  `}
`;

export const StyledIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
`;
